import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const InvisibleLoadingContainer: LoadableType<{}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ReadingAidsInvisibleLoadingContainer" */ '../src/InvisibleLoadingContainer.tsx'
			)
		).InvisibleLoadingContainer,
});
